import axios from 'axios';

const BASE = 'https://alcobrakeadmin.com/v3/us/fullclients';
export const assignmentRows = payload => {
  const rows = payload?.data ?? payload;
  if (Array.isArray(rows)) return rows;
  if (rows && typeof rows === 'object' && (rows.officeId || rows.office_id || rows.id)) return [rows];
  if (rows == null) return [];
  throw new Error('The assignment list could not be read. Please reload and try again.');
};
export const assignmentOfficeId = office => String(office?.officeId ?? office?.office_id ?? office?.id ?? '').trim();

// Always verify against the server; keeping old rows only in React would hide lost assignments.
export async function addOfficerPreservingAssignments(clientId, targetOfficeId, startDate) {
  const read = async () => assignmentRows((await axios.get(`${BASE}/getclientoffices?id=${encodeURIComponent(clientId)}`)).data);
  const add = async (officeId, date) => {
    const response = await axios.post(`${BASE}/addclientoffice`, {
      client_id: String(clientId), office_id: String(officeId), rstartdate: date || ''
    }, { headers: { 'Content-Type': 'application/json' } });
    if (response.data?.success === false || response.data?.error) throw new Error('The server rejected the officer assignment.');
  };
  const previous = await read();
  const target = String(targetOfficeId).trim();
  if (!clientId || !target || previous.some(office => !assignmentOfficeId(office))) {
    throw new Error('An assignment ID is missing. Please reload before assigning an officer.');
  }
  if (!previous.some(office => assignmentOfficeId(office) === target)) await add(target, startDate);
  let saved = await read();
  const missing = previous.filter(office => !saved.some(row => assignmentOfficeId(row) === assignmentOfficeId(office)));
  for (const office of missing) {
    await add(assignmentOfficeId(office), office.Rstartdate || office.rstartdate || startDate);
  }
  if (missing.length) saved = await read();
  const expectedIds = [...previous.map(assignmentOfficeId), target];
  if (expectedIds.some(id => !saved.some(office => assignmentOfficeId(office) === id))) {
    throw new Error('The server did not retain all officer assignments. Please reload and check the assignments; the assignment service needs attention.');
  }
  return saved;
}
